import React, { useEffect, useState } from 'react';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { RiEdit2Line, RiDeleteBin6Line } from 'react-icons/ri';
import Modal from '../../modals/Modal';
import Customerlist from '../customers/Customerlist'


import { useAppContext } from '../../context/AppContext';
import axios from 'axios';
import { Delete, Edit } from 'lucide-react';
import { toast } from 'react-toastify';
// import Products from '../products/Products'
// import { StyledButton } from '../../Shared';


const Customerr = () => {
  const [permitHolders, setPermitHolders] = useState([]);
  const [mailProviders, setMailProviders] = useState([]);
  const [mailOwners, setMailOwners] = useState([]);
  const [modalOpen, setModalOpen] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editType, setEditType] = useState(null);
  const [permits, setPermits] = useState([]);
  const [owners, setOwners] = useState([]);
  const [providers, setProviders] = useState([]);
  const { user, axiUrl } = useAppContext();
  const [reset, setReset] = useState(true);
  const [permit, setPermit] = useState(null);
  const [provider, setProvider] = useState(null);
  const [editPermitItemId, setEditPermitItemId] = useState(null);
  const [permitOpen, setPermitOpen] = useState(false);
  const [ownerOpen, setOwnerOpen] = useState(false);
  const [providerOpen, setProviderOpen] = useState(false);
  const [editOwnerItemId, setEditOwnerItemId] = useState(null);
  const [owner, setOwner] = useState(null);
  const [editProviderItemId, seteditProviderItemId] = useState(null);

  console.log(editProviderItemId);

  useEffect(() => {
    const getperms = async () => {
      await axios
        .post(`${axiUrl}/permits/getpermitholder`, { id: user.company?._id })
        .then((res) => setPermits(res.data));
    };
    const getowners = async () => {
      await axios
        .post(`${axiUrl}/permits/getmailowners`, { id: user.company?._id })
        .then((res) => setOwners(res.data));
    };
    const getproviders = async () => {
      await axios
        .post(`${axiUrl}/permits/getmailproviders`, { id: user.company?._id })
        .then((res) => {
          console.log(res.data);
          setMailProviders(res.data);
        });
    };
    getproviders();
    getperms();
    getowners();
  }, [reset]);

  useEffect(() => {
    const check = async () => {
      if (permitOpen === false) {
        await setPermit(null);
        setEditPermitItemId(null);
        await setPermitOpen(false);
      }
      if (ownerOpen === false) {
        await setOwner(null);
        setEditOwnerItemId(null);
        await setOwnerOpen(false);
      }
      if (providerOpen === false) {
        await setProvider(null);
        seteditProviderItemId(null);
        await setProviderOpen(false);
      }
    };
    check();
  }, [permitOpen, ownerOpen, providerOpen]);



  const generateId = () => Math.random().toString(36).substr(2, 9);

  const openModal = (type, index = null) => {
    setModalOpen(type);
    setEditIndex(index);
    setEditType(type);
  };

  const closeModal = () => {
    setModalOpen(null);
    setEditIndex(null);
    setEditType(null);
  };

  const handleDelete = async (type, item) => {
    if (window.confirm('Are you sure you want to delete this entry?')) {
      if (type === 'permitHolder') {
        await axios
          .post(`${axiUrl}/permits/removepermit`, { id: item._id })
          .then((res) => {
            toast.success(res.data.message);
            setReset(!reset);
          })
          .catch((err) => console.log(err));
      } else if (type === 'mailProvider') {
        await axios
          .post(`${axiUrl}/permits/removeprovider`, { id: item._id })
          .then((res) => {
            toast.success(res.data.message);
            setReset(!reset);
          })
          .catch((err) => console.log(err));
      } else if (type === 'mailOwner') {
        await axios
          .post(`${axiUrl}/permits/removeowner`, { id: item._id })
          .then((res) => {
            toast.success(res.data.message);
            setReset(!reset);
          })
          .catch((err) => console.log(err));
      }
      console.log(`${type} Entry Deleted at index ${item.name}`);
    }
  };

  const formatAddress = (item) => (
    <div>
      {item.address}
      <br />
      {item.address2 && (
        <>
          {item.address2}
          <br />
        </>
      )}
      {item.city}, {item.state}, {item.zip}
    </div>
  );

  const handlePermitEdit = (item) => {
    setEditPermitItemId(item._id);
    setPermit({
      permitName: item.permitName || '',
      companyName: item.companyName || '',
      address: item.address || '',
      address2: item.address2 || '',
      city: item.city || '',
      state: item.state || '',
      zip: item.zip || '',
      isDefault: item.isDefault || false,
      permitType: item.permitType || 'Stamp',
      permitNumber: item.permitNumber || '',
      dueNetNumber: item.dueNetNumber || '',
      accountNumber: item.accountNumber || '',
      bmeu: item.bmeu || '',
      company: user.company?._id
    });
    setPermitOpen(true);
  };

  const handleOwnerEdit = (item) => {
    console.log(item);
    setEditOwnerItemId(item._id);
    setOwner({
      id: item._id,
      template: item.template,
      companyName: item.companyName,
      address: item.address,
      address2: item.address2,
      city: item.city,
      state: item.state,
      zip: item.zip,
      crid: item.crid,
      mid: item.mid,
      nonprofitnumber: item.nonprofitnumber,
      anywhere: item.anywhere,
      company: user.company?._id
    });
    setOwnerOpen(true);
  };

  const handleProviderEdit = (item) => {
    seteditProviderItemId(item._id);
    setProvider({
      id: item._id,
      providerName: item.providerName,
      name: item.name,
      address: item.address,
      address2: item.address2,
      city: item.city,
      state: item.state,
      zip: item.zip,
      telephone: item.telephone,
      crid: item.crid,
      mid: item.mid,
      repname: item.repname,
      repphone: item.repphone,
      repemail: item.repemail,
      einduction: item.einduction,
      seamless: item.seamless,
      company: user.company?._id
    });
    setProviderOpen(true);
  };

  return (
    <div className='relative w-full px-[30px]'>
    
      <div className="w-full p-2 text-3lg">
        <h1 className="text-3lg font-bold text-gray-800 mb-2">  </h1>
        <Tabs className=''>
          <TabList className="flex ">
             
          </TabList>
  <TabPanel><Customerlist /></TabPanel>

        </Tabs>
      </div>
    </div>
  );
};

export default Customerr;